import getAll from './getAll';
import create from './create';
import update from './update';
import deleteItem from './deleteItem';
import moveCatalog from './moveCatalog';
import getTiers from './getTiers';
import createTier from './createTier';
import updateTier from './updateTier';
import deleteTier from './deleteTier';

export default {
  getAll,
  create,
  update,
  deleteItem,
  moveCatalog,
  getTiers,
  createTier,
  updateTier,
  deleteTier,
};
